<ng-container *ngIf="control">
	<div
		[ngClass]="{
			'border-active': !showErrors && hasValue,
			'border-error': showErrors
		}"
		class="border-checkbox checkbox-details"
		[class.disabled]="isDisabled"
	>
		<div class="accordion" id="accordionExample">
			<div class="accordion-item" [class.disabled]="isDisabled">
				<div class="accordion-header">
					<div class="d-flex justify-content-between flex-wrap">
						<div>
							<input
								[class.is-invalid]="showErrors"
								[formControl]="control"
								type="checkbox"
								class="form-check-input cursor-pointer me-2"
								[id]="idTitle"
							/>
							<label
								class="form-check-label cursor-pointer checkbox-title"
								[for]="idTitle"
								>{{ options.title }}</label
							>
						</div>
						<div>
							<span class="text-muted">{{
								options.subtitle
							}}</span>
							<button
								*ngIf="showCollapseButton"
								class="ms-2 accordion-button"
								type="button"
								data-bs-toggle="collapse"
								[attr.data-bs-target]="target"
								aria-expanded="true"
								[attr.aria-controls]="idCollpase"
							></button>
						</div>
					</div>
				</div>
				<div
					[id]="idCollpase"
					class="accordion-collapse collapse show"
					aria-labelledby="headingOne"
					data-bs-parent="#accordionExample"
				>
					<div class="accordion-body">
						<div class="checkbox-description">
							<span class="text-muted">
								<ng-container
									*ngFor="let desc of options.description"
								>
									<span class="d-block">{{ desc }}</span>
								</ng-container>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>
